<template>
    <div>
        <Form ref="resourceApplicationForm" :model="resourceApplicationForm" :rules="ruleValidate" :label-width="140">
            <!-- 基本信息 -->
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                <Card>
                    <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">
                        {{$t('resourceLifecycle.basicInformation')}}</p>
                    <Row>
                        <Col span="11">
                        <FormItem :label="$t('resourceLifecycle.cloudPlatform')" prop="accountTypeSearchKey">
                            <Select v-model="resourceApplicationForm.accountTypeSearchKey" filterable :transfer="true"
                                    @on-change="changeAccountTypeSearchKey(resourceApplicationForm.accountTypeSearchKey)">
                                <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="11">
                        <FormItem :label="$t('resourceLifecycle.accountId')" prop="accountId">
                            <Select v-model="resourceApplicationForm.accountId" filterable
                                    @on-change="changeAccountId(resourceApplicationForm.accountId)" :transfer="true">
                                <Option :value="item.id" v-for="item in accountList" :key="item.id">{{item.name}}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="11">
                        <FormItem :label="$t('resourceLifecycle.region')" prop="region">
                            <Select v-model="resourceApplicationForm.region" filterable
                                    @on-change="changeRegion(resourceApplicationForm.region)" filterable
                                    :transfer="true">
                                <Option :value="item.name" v-for="item in regionList" :key="item.name">{{item.name}}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>

                    <!-- 当云平台为Azure时 显示资源组下拉框 -->
                    <Row>
                        <Col span="11" v-if="resourceApplicationForm.accountTypeSearchKey==2">
                        <FormItem :label="$t('resourceLifecycle.resourceGroup')" prop="resourceGroup">
                            <Select v-model="resourceApplicationForm.resourceGroup" filterable
                                    @on-change="changeResourceGroup(resourceApplicationForm.resourceGroup)" filterable
                                    :transfer="true">
                                <Option :value="item.name" v-for="item in resourceGroupList" :key="item.name">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="11">
                        <FormItem :label="$t('resourceLifecycle.resourceType')" prop="resourceType">
                            <Select v-model="resourceApplicationForm.resourceType" filterable
                                    @on-change="changeResourceType(resourceApplicationForm.resourceType)">
                                <Option :value="item.id" v-for="item in resourceTypeList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="11">
                        <FormItem :label="$t('resourceLifecycle.environment')" prop="environment">
                            <Select v-model="resourceApplicationForm.environment" filterable>
                                <Option :value="item.id" v-for="item in environmentList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="11">
                        <FormItem :label="$t('resourceLifecycle.use')" prop="use">
                            <Input v-model="resourceApplicationForm.use"
                                   :placeholder="$t('resourceLifecycle.pleaseEnter')"/>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="11">
                        <FormItem :label="$t('resourceLifecycle.process')" prop="approvalFlow">
                            <Select v-model="resourceApplicationForm.approvalFlow" filterable>
                                <Option :value="item.id" v-for="(item,index) in approvalFlowList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="11">
                        <FormItem :label="$t('resourceLifecycle.periodOfUse')" prop="periodOfUse">
                            <InputNumber v-model="resourceApplicationForm.periodOfUse" @on-change="queryPrice"
                                         :placeholder="$t('resourceLifecycle.pleaseEnter')"/>
                            {{$t('resourceLifecycle.months')}}
                        </FormItem>
                        </Col>
                    </Row>
                </Card>
                </Col>
            </Row>

            <!-- 资源配置 -->
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                <Card>
                    <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">
                        {{$t('resourceLifecycle.resourceConfig')}}</p>
                    <!-- aws虚拟机 -->
                    <amazon-virtual-machine
                            v-if="resourceApplicationForm.accountTypeSearchKey==0&&resourceApplicationForm.resourceType==0"
                            ref="amazonVirtualMachine"
                            :cost="cost" @success="success"
                            :allUpfrontOneYearPrice="allUpfrontOneYearPrice" @getAllUpfrontOneYearPrice="getAllUpfrontOneYearPrice"
                            :noUpfrontOneYearPrice="noUpfrontOneYearPrice" @getNoUpfrontOneYearPrice="getNoUpfrontOneYearPrice"
                            :amazonResourceApplicationBasicInfoForm="resourceApplicationForm"></amazon-virtual-machine>
                    <!-- aws虚拟网络 -->
                    <amazon-virtual-network
                            v-if="resourceApplicationForm.accountTypeSearchKey==0&&resourceApplicationForm.resourceType==1"
                            ref="amazonVirtualNetwork"
                            :cost="cost" @success="success"
                            :amazonResourceApplicationBasicInfoForm="resourceApplicationForm"></amazon-virtual-network>
                    <!-- aws对象存储 -->
                    <amazon-object-storage
                            v-if="resourceApplicationForm.accountTypeSearchKey==0&&resourceApplicationForm.resourceType==2"
                            ref="amazonObjectStorage"
                            :cost="cost" @success="success"
                            :amazonResourceApplicationBasicInfoForm="resourceApplicationForm"></amazon-object-storage>
                    <!-- aws托管数据库 -->
                    <amazon-managed-database
                            v-if="resourceApplicationForm.accountTypeSearchKey==0&&resourceApplicationForm.resourceType==3"
                            ref="amazonManagedDatabase"
                            :cost="cost" @success="success"
                            :amazonResourceApplicationBasicInfoForm="resourceApplicationForm"></amazon-managed-database>
                    <!-- aws弹性IP -->
                    <amazon-elastic-address
                            v-if="resourceApplicationForm.accountTypeSearchKey==0&&resourceApplicationForm.resourceType==4"
                            ref="amazonElasticAddress"
                            :cost="cost" @success="success"
                            :amazonResourceApplicationBasicInfoForm="resourceApplicationForm"></amazon-elastic-address>

                    <!-- azure虚拟机 -->
                    <azure-virtual-machine
                            v-if="resourceApplicationForm.accountTypeSearchKey==2&&resourceApplicationForm.resourceType==0"
                            ref="azureVirtualMachine"
                            :cost="cost" @success="success"
                            :azureResourceApplicationBasicInfoForm="resourceApplicationForm"></azure-virtual-machine>
                    <!-- azure虚拟网络 -->
                    <azure-virtual-network
                            v-if="resourceApplicationForm.accountTypeSearchKey==2&&resourceApplicationForm.resourceType==1"
                            ref="azureVirtualNetwork"
                            :cost="cost" @success="success"
                            :azureResourceApplicationBasicInfoForm="resourceApplicationForm"></azure-virtual-network>
                    <!-- azure对象存储 -->
                    <azure-object-storage
                            v-if="resourceApplicationForm.accountTypeSearchKey==2&&resourceApplicationForm.resourceType==2"
                            ref="azureObjectStorage"
                            :cost="cost" @success="success"
                            :azureResourceApplicationBasicInfoForm="resourceApplicationForm"></azure-object-storage>
                    <!-- azure托管数据库 -->
                    <azure-managed-database
                            v-if="resourceApplicationForm.accountTypeSearchKey==2&&resourceApplicationForm.resourceType==3"
                            ref="azureManagedDatabase"
                            :cost="cost" @success="success"
                            :azureResourceApplicationBasicInfoForm="resourceApplicationForm"></azure-managed-database>
                    <!-- azure弹性IP -->
                    <azure-elastic-address
                            v-if="resourceApplicationForm.accountTypeSearchKey==2&&resourceApplicationForm.resourceType==4"
                            ref="azureElasticAddress"
                            :cost="cost" @success="success"
                            :azureResourceApplicationBasicInfoForm="resourceApplicationForm"></azure-elastic-address>

                    <Row>
                        <Col span="22">
                        <FormItem :label="$t('resourceLifecycle.attachment')" prop="enclosure">
                            <Upload ref="upload" v-model="resourceApplicationForm.enclosure" :on-success="uploadSuccess"
                                    :on-error="uploadError" :headers='{"userName": userName}' multiple type="drag"
                                    :action="actionUrl" :show-upload-list="true" :on-remove="handleRemove">
                                <div>
                                    <Icon type="ios-cloud-upload" size="50" style="color: #3399ff"></Icon>
                                    <p>{{$t('resourceLifecycle.clickordragfilestouploadhere')}}</p>
                                </div>
                            </Upload>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="22">
                        <FormItem :label="$t('resourceLifecycle.remark')" prop="describe">
                            <Input v-model="resourceApplicationForm.describe" type="textarea"
                                   :autosize="{minRows: 2,maxRows: 10}"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                </Card>
                </Col>
            </Row>

            <!-- 预估费用 -->
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                <Card>
                    <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">
                        {{$t('resourceLifecycle.estimatedCost')}}</p>
                    <Row>
                        <Col span="8">
                        <FormItem :label="$t('resourceLifecycle.estimatedCost')" :label-width="200">
                            <i style="font-size: 20px;">￥ {{cost}}</i>
                        </FormItem>
                        </Col>
                        <div v-if="this.resourceApplicationForm.resourceType === 0">
                          <Col span="8">
                            <FormItem :label="$t('resourceLifecycle.purchaseNoUpfrontOneYearPrice')"  :label-width="200">
                              <i style="font-size: 20px;">￥ {{noUpfrontOneYearPrice}}</i>
                            </FormItem>
                          </Col>
                          <Col span="8">
                            <FormItem :label="$t('resourceLifecycle.purchaseAllUpfrontOneYearPrice')"  :label-width="200">
                              <i style="font-size: 20px;">￥ {{allUpfrontOneYearPrice}}</i>
                            </FormItem>
                          </Col>
                        </div>
                    </Row>

                </Card>
                </Col>
            </Row>

            <FormItem style="float: right;">
                <!-- 申请 -->
                <Button type="primary" :loading="addloading" @click="handleSubmit(resourceApplicationForm)">
                    {{$t('resourceLifecycle.application')}}
                </Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
import {setCookie, getCookie, delCookie} from '../../../utils/cookieUtil.js'
// AWS
import AmazonVirtualMachine from "../resource_application/aws/virtual_machine/AmazonVirtualMachine"
import AmazonVirtualNetwork from "../resource_application/aws/virtual_network/AmazonVirtualNetwork"
import AmazonObjectStorage from "../resource_application/aws/object_storage/AmazonObjectStorage"
import AmazonManagedDatabase from "../resource_application/aws/managed_database/AmazonManagedDatabase"
import AmazonElasticAddress from "../resource_application/aws/elastic_ip/AmazonElasticAddress"

// Azure
import AzureVirtualMachine from "../resource_application/azure/virtual_machine/AzureVirtualMachine"
import AzureVirtualNetwork from '../resource_application/azure/virtual_network/AzureVirtualNetwork'
import AzureObjectStorage from '../resource_application/azure/object_storage/AzureObjectStorage'
import AzureManagedDatabase from '../resource_application/azure/managed_database/AzureManagedDatabase'
import AzureElasticAddress from '../resource_application/azure/elastic_ip/AzureElasticAddress'

import {CLOUD_PLATFORM_ID, buildPlatformOptions} from '../../../utils/cloudPlatform.js'

export default {
  name: 'BasicInformation',
  components: {
    AmazonVirtualMachine,
    AmazonVirtualNetwork,
    AmazonObjectStorage,
    AmazonManagedDatabase,
    AmazonElasticAddress,
    AzureVirtualMachine,
    AzureVirtualNetwork,
    AzureObjectStorage,
    AzureManagedDatabase,
    AzureElasticAddress
  },
  data() {
    return {
      company: getCookie(global.companyId),
      cost: 0,
      allUpfrontOneYearPrice: 0,
      noUpfrontOneYearPrice: 0,
      addloading: false,
      attachmentIDs: [],
      userName: getCookie(global.cookieName),
      actionUrl: '', //附件
      accountList: [],
      regionList: [],
      resourceGroupList: [],
      storageAccountList: [],
      resourceTypeList: [{
        id: 0,
        name: this.$t("resourceLifecycle.virtualMachine")
      },
        {
          id: 1,
          name: this.$t("resourceLifecycle.virtualNetwork")
        },
        {
          id: 2,
          name: this.$t("resourceLifecycle.objectStorage")
        },
        {
          id: 3,
          name: this.$t("resourceLifecycle.database")
        },
        {
          id: 4,
          name: this.$t("resourceLifecycle.elasticIP")
        }],
      environmentList: [{
        id: 0,
        name: this.$t("resourceLifecycle.produce")
      }, {
        id: 1,
        name: this.$t("resourceLifecycle.development")
      }],
      approvalFlowList: [],
      accountTypeList: buildPlatformOptions([
        CLOUD_PLATFORM_ID.AWS,
        CLOUD_PLATFORM_ID.AZURE
      ]),
      resourceApplicationForm: {
        accountTypeSearchKey: 0,
        accountId: null,
        resourceGroup: '',
        region: '',
        use: '',
        periodOfUse: 1,
        resourceType: 0,
        environment: 0,
        approvalFlow: null,
        describe: ''
      },
      ruleValidate: {
        accountTypeSearchKey: [
          {
            required: true,
            message: this.$t("resourceLifecycle.pleasechoosecloudplatform"),
            trigger: 'blur',
            type: 'number'
          }
        ],
        accountId: [
          {
            required: true,
            message: this.$t("resourceLifecycle.pleaseselectanaccount"),
            trigger: 'change',
            type: 'number'
          }
        ],
        region: [
          {required: true, message: this.$t("resourceLifecycle.pleaseselectaregion"), trigger: 'change'}
        ],
        use: [
          {required: true, message: this.$t("resourceLifecycle.useCannotbeempty"), trigger: 'blur'}
        ],
        periodOfUse: [
          {
            required: true,
            message: this.$t("resourceLifecycle.theexpirationdatecannotbeempty"),
            trigger: 'blur',
            type: 'number'
          }
        ],
        resourceType: [
          {
            required: true,
            message: this.$t("resourceLifecycle.pleaseselectresourcetype"),
            trigger: 'change',
            type: 'number'
          }
        ],
        resourceGroup: [
          {required: true, message: this.$t("resourceLifecycle.pleaseselectresourcegroup"), trigger: 'change'}
        ],
        environment: [
          {
            required: true,
            message: this.$t("resourceLifecycle.pleaseselectresourceenvironment"),
            trigger: 'change',
            type: 'number'
          }
        ],
        approvalFlow: [
          {
            required: true,
            message: this.$t("resourceLifecycle.pleaseselectresourceprocess"),
            trigger: 'change',
            type: 'number'
          }
        ],
        describe: [
          {required: false, message: this.$t("resourceLifecycle.pleaseenterabackup"), trigger: 'blur'}
        ]
      }
    }
  },
  mounted: function () {
    // 上传附件接口
    this.actionUrl = process.env.API_ROOT + '/sme/file/uploadFileS3';
    this.selectAccountByType();
    this.selectListNames();
  },
  watch: {
    cost: {
      handler(val) {
        this.changeCost(val);
      },
      immediate: true
    }
  },
  methods: {
    success(params) {
      this.cost = params;
    },
    // 获取预付全费一年价格
    getAllUpfrontOneYearPrice(params) {
      this.allUpfrontOneYearPrice = params;
    },
    // 获取无预付一年价格
    getNoUpfrontOneYearPrice(params) {
      this.noUpfrontOneYearPrice = params;
    },
    queryPrice: function () {
      if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 0) {
        this.$refs.amazonVirtualMachine.queryAWSInstancePrice();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 2) {
        this.$refs.amazonObjectStorage.queryAWSS3Price();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 3) {
        this.$refs.amazonManagedDatabase.queryAWSRDSPrice();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 4) {
        this.$refs.amazonElasticAddress.queryAWSEipPrice();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 0) {
        this.$refs.azureVirtualMachine.queryAzureVMPrice();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 2) {
        this.$refs.azureObjectStorage.queryAzureObjectStoragePrice();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 3) {
        this.$refs.azureManagedDatabase.queryAzureDatabasePrice();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 4) {
        this.$refs.azureElasticAddress.queryAzurePublicIpPrice();
      }
    },
    // 当云平台为AWS时
    showAllAws: function () {
      // 虚拟机
      if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 0) {
        this.$refs.amazonVirtualMachine.showAll();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 1) {
        this.$refs.amazonVirtualNetwork.showAll();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 2) {
        this.$refs.amazonObjectStorage.showAll();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 3) {
        this.$refs.amazonManagedDatabase.showAll();
      }
    },
    // 当云平台为Azure时
    showAllAzure: function () {
      // 虚拟机
      if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 0) {
        this.$refs.azureVirtualMachine.showAll();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 2) {
        this.$refs.azureObjectStorage.showAll();
      } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 3) {
        this.$refs.azureManagedDatabase.showAll();
      }
    },
    // 切换云平台
    changeAccountTypeSearchKey: function () {
      this.selectAccountByType();
      this.queryRegionsByAccount();
    },
    // 切换资源类型
    changeResourceType: function () {
      this.$nextTick(() => {
        this.showAllAws();
        this.showAllAzure();
      })
    },
    /*********************区域*******************************/
    // 查询区域
    queryRegionsByAccount: function () {
      this.$api.account.queryAccountRegions("accountId", this.resourceApplicationForm.accountId)
        .then(res => {
          this.regionList = res.data;
          this.resourceApplicationForm.region = this.regionList[0].name;
        })
    },
    //切换region
    changeRegion: function () {
      this.showAllAws();
      this.showAllAzure();
    },
    /*********************账号*******************************/
    //查询账号
    selectAccountByType: function () {
      this.$api.account.selectAccountByType("type", this.resourceApplicationForm.accountTypeSearchKey)
        .then(res => {
          this.accountList = res.data;
          if (this.accountList.length > 0) {
            this.resourceApplicationForm.accountId = this.accountList[0].id;
            // 查询区域
            this.$api.account.queryAccountRegions("accountId", this.resourceApplicationForm.accountId)
              .then(res => {
                this.regionList = res.data;
                this.resourceApplicationForm.region = this.regionList[0].name;
                this.showAllAws();
              })

            // 云平台为Azure 查询资源组
            if (this.resourceApplicationForm.accountTypeSearchKey == 2) {
              this.$api.lifecycleResourceApplication.queryResourceGroupList({
                "accountId": this.resourceApplicationForm.accountId
              })
                .then(res => {
                  this.resourceGroupList = res.data;
                  this.resourceApplicationForm.resourceGroup = this.resourceGroupList[0].name;
                  this.showAllAzure();
                })
            }
          }

        })
    },
    // 切换账号
    changeAccountId: function () {
      this.queryRegionsByAccount();
      this.showAllAws();
      // 云平台为Azure 查询资源组
      if (this.resourceApplicationForm.accountTypeSearchKey == 2) {
        this.queryResourceGroupList();
        this.showAllAzure();
      }
    },
    /*********************Azure资源组*******************************/
    //查询Azure资源组
    queryResourceGroupList: function () {
      this.$api.lifecycleResourceApplication.queryResourceGroupList({
        "accountId": this.resourceApplicationForm.accountId
      })
        .then(res => {
          this.resourceGroupList = res.data;
          this.resourceApplicationForm.resourceGroup = this.resourceGroupList[0].name;
        })
    },
    // 切换资源组
    changeResourceGroup: function () {
      this.showAllAzure();
    },
    // 花费更改
    changeCost: function(val){
       // 只有冠闵用户才会启用该逻辑
       if (this.StringUtils.isNotEmpty(val) && this.StringUtils.isNotEmpty(this.company) && this.company == 1){
         this.$api.lifecycleResourceApplication.switchApprovalStreamsBasedByPrice({
           "price": val,
           "processTemplateType": 7
         }).then(res => {
              // 切换审批流
             this.resourceApplicationForm.approvalFlow = res.data.id;
         })
       }
    },
    /*********************审批流*******************************/
    // 审批流
    selectListNames: function () {
      this.$api.processTemplate.selectListNames({
        "type": 7
      })
        .then(res => {
          if (res.data) {
            this.approvalFlowList = res.data;
            if (this.approvalFlowList.length > 0) {
              this.resourceApplicationForm.approvalFlow = this.approvalFlowList[0].id;
            }
          }
        })
    },
    /*********************附件*********************************/
    // 上传成功
    uploadSuccess(res, file, fileList) {
      this.$Message.success(this.$t("resourceLifecycle.response.uploadSuccess"));
      this.attachmentIDs.push(file.response.id);
      this.id = file.response.id;
    },
    // 上传失败
    uploadError(error, file) { //上传失败
      this.$Message.error(this.$t("resourceLifecycle.response.uploadFail"));
    },
    // 删除附件
    handleRemove(file, fileList) {
      this.$api.file.deleteAttatchment("id", file.response.id)
        .then(res => {
          this.$Message.success(this.$t("resourceLifecycle.response.deleteSuccess"));
          this.attachmentIDs = [];
          for (var i = 0; i < fileList.length; i++) {
            this.attachmentIDs.push(fileList[i].response.id)
          }
        })
    },
    /*********************申请*********************************/
    handleSubmit: function (name) {
      this.$refs.resourceApplicationForm.validate((valid) => {

        //aws虚拟机资源中是否存在key为Name的标签
        let awsFlag = this.verifyAWSVMTagKey();

        //azure虚拟机资源中是否存在key为Name的标签
        let azureFlag = this.verifyAzureVMTagKey();

        if (valid && awsFlag && azureFlag) {
          var submitLifecycleResourceApplicationDTO = {
            "platform": this.resourceApplicationForm.accountTypeSearchKey,
            "accountId": this.resourceApplicationForm.accountId,
            "region": this.resourceApplicationForm.region,
            "lifecycleResourceType": this.resourceApplicationForm.resourceType,
            "environment": this.resourceApplicationForm.environment,
            "usageNote": this.resourceApplicationForm.use,
            "processTemplateId": this.resourceApplicationForm.approvalFlow,
            "duration": this.resourceApplicationForm.periodOfUse,
            "attachmentIDs": this.attachmentIDs,
            "remark": this.resourceApplicationForm.describe,
            "cost": this.cost
          };

          if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 0) {
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.amazonVirtualMachine.resourceApplicationForm.name;
            // AWS 虚拟机
            submitLifecycleResourceApplicationDTO.lifecycleResourceInstanceDTO = {
              "accountId": this.resourceApplicationForm.accountId,
              "region": this.resourceApplicationForm.region,
              "platform": this.resourceApplicationForm.accountTypeSearchKey,
              "name": this.$refs.amazonVirtualMachine.resourceApplicationForm.name,
              "instanceType": this.$refs.amazonVirtualMachine.resourceApplicationForm.instanceType,
              "instanceNumber": this.$refs.amazonVirtualMachine.resourceApplicationForm.numberOfInstances,
              "cpu": this.$refs.amazonVirtualMachine.resourceApplicationForm.cpu,
              "ram": this.$refs.amazonVirtualMachine.resourceApplicationForm.ram,
              "vpc": this.$refs.amazonVirtualMachine.resourceApplicationForm.vpc,
              "virtualNetworkSubnet": this.$refs.amazonVirtualMachine.resourceApplicationForm.subnet,
              "securityGroup": this.$refs.amazonVirtualMachine.resourceApplicationForm.securityGroup,
              "keyPair": this.$refs.amazonVirtualMachine.resourceApplicationForm.keyName,
              "isMonitor": this.$refs.amazonVirtualMachine.resourceApplicationForm.monitor,
              "isTerminationProtect": this.$refs.amazonVirtualMachine.resourceApplicationForm.enableTerminationProtection,
              "isAllocationPublicIp": this.$refs.amazonVirtualMachine.resourceApplicationForm.automaticallyAssignPublicIP,
              "lifecycleResourceInstanceOsDTO": {
                "osPlatform": this.$refs.amazonVirtualMachine.resourceApplicationForm.os,
                "osArchitecture": this.$refs.amazonVirtualMachine.resourceApplicationForm.mirror
              }
            }
            // AWS 磁盘
            submitLifecycleResourceApplicationDTO.lifecycleResourceVolumeDTOS = []
            var awsVolumeList = this.$refs.amazonVirtualMachine.awsVolumeList
            for (var i = 0; i < awsVolumeList.length; i++) {
              var lifecycleResourceVolumeDTO = {
                "accountId": this.resourceApplicationForm.accountId,
                "region": this.resourceApplicationForm.region,
                "awsZone": awsVolumeList[i].availabilityZone,
                "encrypted": awsVolumeList[i].isEncryption,
                "type": awsVolumeList[i].volumeType,
                "capacity": awsVolumeList[i].size,
                "iops": awsVolumeList[i].IOPS,
              }
              submitLifecycleResourceApplicationDTO.lifecycleResourceVolumeDTOS.push(lifecycleResourceVolumeDTO)
            }
            // AWS 标签
            submitLifecycleResourceApplicationDTO.resourceTags = this.$refs.amazonVirtualMachine.resourceApplicationForm.tags;
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 1) {
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.amazonVirtualNetwork.resourceApplicationForm.name;
            // AWS 虚拟网络
            submitLifecycleResourceApplicationDTO.vpcDTO = {
              "accountId": this.resourceApplicationForm.accountId,
              "region": this.resourceApplicationForm.region,
              "cidrBlock": this.$refs.amazonVirtualNetwork.resourceApplicationForm.IPV4,
              "amazonProvidedIpv6CidrBlock": this.$refs.amazonVirtualNetwork.resourceApplicationForm.IPV6,
              "vpcName": this.$refs.amazonVirtualNetwork.resourceApplicationForm.name,
              "instanceTenancy": this.$refs.amazonVirtualNetwork.resourceApplicationForm.hardwareLease,
              "subnetDTO": {
                "accountId": this.resourceApplicationForm.accountId,
                "region": this.resourceApplicationForm.region,
                "subnetName": this.$refs.amazonVirtualNetwork.resourceApplicationForm.subnetName,
                "cidrBlock": this.$refs.amazonVirtualNetwork.resourceApplicationForm.subnetIPV4,
                "availabilityZone": this.$refs.amazonVirtualNetwork.resourceApplicationForm.availableArea
              }
            }
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 2) {
            // AWS 对象存储
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.amazonObjectStorage.resourceApplicationForm.name;
            submitLifecycleResourceApplicationDTO.lifecycleResourceObjectStorageDTO =
              {
                "accountId": this.resourceApplicationForm.accountId,
                "region": this.resourceApplicationForm.region,
                "platform": this.resourceApplicationForm.accountTypeSearchKey,
                "bucketName": this.$refs.amazonObjectStorage.resourceApplicationForm.name,
                "sourceBucket": this.$refs.amazonObjectStorage.resourceApplicationForm.copySettings
              }
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 3) {
            // AWS 托管数据库
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.amazonManagedDatabase.resourceApplicationForm.databaseName;
            submitLifecycleResourceApplicationDTO.lifecycleResourceAwsDatabaseDTO =
              {
                "accountId": this.resourceApplicationForm.accountId,
                "region": this.resourceApplicationForm.region,
                "databaseId": this.$refs.amazonManagedDatabase.resourceApplicationForm.databaseName,
                "engine": this.$refs.amazonManagedDatabase.resourceApplicationForm.databaseEngine,
                "versions": this.$refs.amazonManagedDatabase.resourceApplicationForm.databaseVersion,
                "engineVersion": this.$refs.amazonManagedDatabase.resourceApplicationForm.databaseEngineVersion,
                "dbInstanceClass": this.$refs.amazonManagedDatabase.resourceApplicationForm.databaseInstanceClass,
                "multiAZ": this.$refs.amazonManagedDatabase.resourceApplicationForm.multiAZDeployment,
                "allocatedStorage": this.$refs.amazonManagedDatabase.resourceApplicationForm.allocatedStorageSpace,
                "storageType": this.$refs.amazonManagedDatabase.resourceApplicationForm.storageType,
                "iops": this.$refs.amazonManagedDatabase.resourceApplicationForm.presetIOPS,
                "masterUsername": this.$refs.amazonManagedDatabase.resourceApplicationForm.masterUsername,
                "masterUserPassword": this.$refs.amazonManagedDatabase.resourceApplicationForm.password,
                "port": this.$refs.amazonManagedDatabase.resourceApplicationForm.port,
                "optionGroupName": this.$refs.amazonManagedDatabase.resourceApplicationForm.optionGroup,
                "dbParameterGroupName": this.$refs.amazonManagedDatabase.resourceApplicationForm.databaseParameterGroup,
                "enableIAMDatabaseAuthentication": this.$refs.amazonManagedDatabase.resourceApplicationForm.iamDatabaseAuthentication,
                "vpcId": this.$refs.amazonManagedDatabase.resourceApplicationForm.vpc,
                "dbSubnetGroupName": this.$refs.amazonManagedDatabase.resourceApplicationForm.subnetGroup,
                "publiclyAccessible": this.$refs.amazonManagedDatabase.resourceApplicationForm.publicAvailability,
                "availabilityZone": this.$refs.amazonManagedDatabase.resourceApplicationForm.availabilityZone,
                "vpcGroup": this.$refs.amazonManagedDatabase.resourceApplicationForm.vpcSecurityGroup,
                "copyTagsToSnapshot": this.$refs.amazonManagedDatabase.resourceApplicationForm.copyTagsToSnapshot,
                "deletionProtection": this.$refs.amazonManagedDatabase.resourceApplicationForm.enableDeleteProtection,
                "dbParameterGroupFamily": this.$refs.amazonManagedDatabase.dbParameterGroupFamily
              }
            if (submitLifecycleResourceApplicationDTO.lifecycleResourceAwsDatabaseDTO.vpcGroup == 1) {
              submitLifecycleResourceApplicationDTO.lifecycleResourceAwsDatabaseDTO.vpcSecurityGroupIds = this.$refs.amazonManagedDatabase.resourceApplicationForm.existingSecurityGroup;
            }
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 0 && this.resourceApplicationForm.resourceType == 4) {
            // AWS 弹性IP
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.amazonElasticAddress.resourceApplicationForm.name;

          } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 0) {
            // Azure 虚拟机
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.azureVirtualMachine.resourceApplicationForm.name;
            submitLifecycleResourceApplicationDTO.lifecycleResourceInstanceDTO = {
              "accountId": this.resourceApplicationForm.accountId,
              "region": this.resourceApplicationForm.region,
              "platform": this.resourceApplicationForm.accountTypeSearchKey,
              "name": this.$refs.azureVirtualMachine.resourceApplicationForm.name,
              "instanceType": this.$refs.azureVirtualMachine.resourceApplicationForm.instanceType,
              "resourceGroup": this.resourceApplicationForm.resourceGroup,
              "instanceNumber": this.$refs.azureVirtualMachine.resourceApplicationForm.numberOfInstances,
              "cpu": this.$refs.azureVirtualMachine.resourceApplicationForm.cpu,
              "ram": this.$refs.azureVirtualMachine.resourceApplicationForm.memory,
              "vpc": this.$refs.azureVirtualMachine.resourceApplicationForm.vpc,
              "virtualNetworkSubnet": this.$refs.azureVirtualMachine.resourceApplicationForm.subnet,
              "securityGroup": this.$refs.azureVirtualMachine.resourceApplicationForm.securityGroup,
              "storageAccount": this.$refs.azureVirtualMachine.resourceApplicationForm.storageAccount,
              "userName": this.$refs.azureVirtualMachine.resourceApplicationForm.userName,
              "password": this.$refs.azureVirtualMachine.resourceApplicationForm.password,
              "isAllocationPublicIp": this.$refs.azureVirtualMachine.resourceApplicationForm.automaticallyAssignPublicIP,
              "lifecycleResourceInstanceOsDTO": {
                "osPlatform": this.$refs.azureVirtualMachine.resourceApplicationForm.os,
                "osVersion": this.$refs.azureVirtualMachine.resourceApplicationForm.mirror
              }
            }
            // Azure 磁盘
            submitLifecycleResourceApplicationDTO.lifecycleResourceVolumeDTOS = [{
              "accountId": this.resourceApplicationForm.accountId,
              "region": this.resourceApplicationForm.region,
              "type": this.$refs.azureVirtualMachine.resourceApplicationForm.diskType
            }]
            // Azure 标签
            submitLifecycleResourceApplicationDTO.resourceTags = this.$refs.azureVirtualMachine.resourceApplicationForm.tags;
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 1) {
            // Azure 虚拟网络
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.azureVirtualNetwork.resourceApplicationForm.name;
            submitLifecycleResourceApplicationDTO.lifecycleResourceAzureVirtualNetworkDTO = {
              "name": this.$refs.azureVirtualNetwork.resourceApplicationForm.name,
              "resourceGroup": this.resourceApplicationForm.resourceGroup,
              "addressSpace": this.$refs.azureVirtualNetwork.resourceApplicationForm.addressRange
            }
            // 子网
            submitLifecycleResourceApplicationDTO.lifecycleResourceAzureVirtualNetworkDTO.lifecycleResourceAzureSubnetDTOList = []
            var subnetData = this.$refs.azureVirtualNetwork.subnetData
            for (var i = 0; i < subnetData.length; i++) {
              var lifecycleResourceAzureSubnetDTO = {
                "name": subnetData[i].name,
                "addressSpace": subnetData[i].addressSpace
              }
              submitLifecycleResourceApplicationDTO.lifecycleResourceAzureVirtualNetworkDTO.lifecycleResourceAzureSubnetDTOList.push(lifecycleResourceAzureSubnetDTO)
            }
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 2) {
            // Azure 对象存储
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.azureObjectStorage.resourceApplicationForm.name;
            submitLifecycleResourceApplicationDTO.azureStorageRequestDTO = {
              "location": this.resourceApplicationForm.region,
              "blobName": this.$refs.azureObjectStorage.resourceApplicationForm.name,
              "storageAccountName": this.$refs.azureObjectStorage.resourceApplicationForm.storageAccount,
              "resourceGroupName": this.resourceApplicationForm.resourceGroup,
              "azurePublicAccess": this.$refs.azureObjectStorage.resourceApplicationForm.pulicLevel
            }
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 3 && this.$refs.azureManagedDatabase.resourceApplicationForm.databaseType == 5) {
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.azureManagedDatabase.resourceApplicationForm.name;
            submitLifecycleResourceApplicationDTO.lifecycleResourceType = 5;
            // Azure 托管数据库&&数据库类型为"Azure MySQL 服务器"
            submitLifecycleResourceApplicationDTO.lifecycleResourceAzureMySQLDTO = {
              "accountId": this.resourceApplicationForm.accountId,
              "location": this.resourceApplicationForm.region,
              "resourceGroup": this.resourceApplicationForm.resourceGroup,

              "dbName": this.$refs.azureManagedDatabase.resourceApplicationForm.name,
              "storage": this.$refs.azureManagedDatabase.resourceApplicationForm.storage,
              "administratorLogin": this.$refs.azureManagedDatabase.resourceApplicationForm.userName,
              "administratorLoginPassword": this.$refs.azureManagedDatabase.resourceApplicationForm.password,
              "serverVersion": this.$refs.azureManagedDatabase.resourceApplicationForm.mySqulVersion,
              "skuTier": this.$refs.azureManagedDatabase.resourceApplicationForm.serverType,
              "skuCapacity": this.$refs.azureManagedDatabase.resourceApplicationForm.skuCapacity,
              "backupRetentionDays": this.$refs.azureManagedDatabase.resourceApplicationForm.backupRetentionDays,
              "geoRedundantBackup": this.$refs.azureManagedDatabase.resourceApplicationForm.geoRedundantBackup,
              "storageAutoGrow": this.$refs.azureManagedDatabase.resourceApplicationForm.storageAutoGrow
            }
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 3 && this.$refs.azureManagedDatabase.resourceApplicationForm.databaseType == 6) {
            // Azure 托管数据库&&数据库类型为"Azure MariaDB 服务器"
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.azureManagedDatabase.resourceApplicationForm.name;
            submitLifecycleResourceApplicationDTO.lifecycleResourceType = 6;
            submitLifecycleResourceApplicationDTO.lifecycleResourceAzureMariaDBDTO = {
              "accountId": this.resourceApplicationForm.accountId,
              "location": this.resourceApplicationForm.region,
              "resourceGroup": this.resourceApplicationForm.resourceGroup,

              "dbName": this.$refs.azureManagedDatabase.resourceApplicationForm.name,
              "storage": this.$refs.azureManagedDatabase.resourceApplicationForm.storage,
              "administratorLogin": this.$refs.azureManagedDatabase.resourceApplicationForm.userName,
              "administratorLoginPassword": this.$refs.azureManagedDatabase.resourceApplicationForm.password,
              "serverVersion": this.$refs.azureManagedDatabase.resourceApplicationForm.mariaDBVersion,
              "skuTier": this.$refs.azureManagedDatabase.resourceApplicationForm.serverType,
              "skuCapacity": this.$refs.azureManagedDatabase.resourceApplicationForm.skuCapacity,
              "backupRetentionDays": this.$refs.azureManagedDatabase.resourceApplicationForm.backupRetentionDays,
              "geoRedundantBackup": this.$refs.azureManagedDatabase.resourceApplicationForm.geoRedundantBackup,
              "storageAutoGrow": this.$refs.azureManagedDatabase.resourceApplicationForm.storageAutoGrow
            }
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 3 && this.$refs.azureManagedDatabase.resourceApplicationForm.databaseType == 7) {
            // Azure 托管数据库&&数据库类型为"Azure Redis 服务器"
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.azureManagedDatabase.resourceApplicationForm.dnsName;
            submitLifecycleResourceApplicationDTO.lifecycleResourceType = 7;
            submitLifecycleResourceApplicationDTO.lifecycleResourceAzureRedisDTO = {
              "accountId": this.resourceApplicationForm.accountId,
              "location": this.resourceApplicationForm.region,
              "resourceGroup": this.resourceApplicationForm.resourceGroup,
              "redisName": this.$refs.azureManagedDatabase.resourceApplicationForm.dnsName,
              "pricingTier": this.$refs.azureManagedDatabase.resourceApplicationForm.pricingLayer,
              "enableNonSslPort": this.$refs.azureManagedDatabase.resourceApplicationForm.enableNonSslPort
            }
          } else if (this.resourceApplicationForm.accountTypeSearchKey == 2 && this.resourceApplicationForm.resourceType == 4) {
            // Azure 弹性IP
            submitLifecycleResourceApplicationDTO.lifecycleResourceName = this.$refs.azureElasticAddress.resourceApplicationForm.name;
            submitLifecycleResourceApplicationDTO.azureEIPRequestDTO = {
              "location": this.resourceApplicationForm.region,
              "eipName": this.$refs.azureElasticAddress.resourceApplicationForm.name,
              "publicIPSkuType": this.$refs.azureElasticAddress.resourceApplicationForm.sku,
              "resourceGroupName": this.resourceApplicationForm.resourceGroup,
              "ipAllocationMethod": this.$refs.azureElasticAddress.resourceApplicationForm.assign
            }
          }
          // this.addloading=true;
          // 提交资源申请
          this.$api.lifecycleResourceApplication.submitLifecycleResourceApplication(submitLifecycleResourceApplicationDTO)
            .then(res => {
              // this.addloading=false;
              this.$Message.success(this.$t("resourceLifecycle.successfulApplication"));
              this.$router.push({path: '/approvalTask', query: {t: Date.now()}});
            })
            .catch(error => {
              if (error.status == 500) {
                // this.addloading = false;
                setTimeout(() => {
                  // this.addloading = true
                }, 0)
              }
            })
        }
      })
    },
    verifyAWSVMTagKey(){
      let flag = true;
      if (this.$refs.amazonVirtualMachine != undefined){
        for (const tag of this.$refs.amazonVirtualMachine.resourceApplicationForm.tags) {
          if ('Name' === tag.key){
            flag = false;
            break;
          }
        }
      }
      return flag;
    },
    verifyAzureVMTagKey(){
      let flag = true;
      if (this.$refs.azureVirtualMachine != undefined){
        for (const tag of this.$refs.azureVirtualMachine.resourceApplicationForm.tags) {
          if ('Name' === tag.key){
            flag = false;
            break;
          }
        }
      }
      return flag;
    }
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/BasicInformation.vue